import { createStore } from "@xstate/store";

type RootStoreContext = {
  parentUrl: string | null;
  primaryColorOverride: string | null;
  primaryTextColorOverride: string | null;
  backgroundUrlOverride: string | null;
  logoUrlOverride: string | null;
};

type RootStoreEventPayloads = {
  SET_PARENT_URL: { parentUrl: string | null };
  SET_THEME_OVERRIDES: {
    primaryColor: string | null;
    primaryTextColor: string | null;
    backgroundUrl: string | null;
    logoUrl: string | null;
  };
};

export const rootStore = createStore<RootStoreContext, RootStoreEventPayloads, Record<string, never>>({
  context: {
    parentUrl: null as string | null,
    primaryColorOverride: null as string | null,
    primaryTextColorOverride: null as string | null,
    backgroundUrlOverride: null as string | null,
    logoUrlOverride: null as string | null,
  },
  on: {
    SET_PARENT_URL: (context, event: { parentUrl: string | null }) => ({
      ...context,
      parentUrl: event.parentUrl,
    }),
    SET_THEME_OVERRIDES: (
      context,
      event: {
        primaryColor: string | null;
        primaryTextColor: string | null;
        backgroundUrl: string | null;
        logoUrl: string | null;
      },
    ) => ({
      ...context,
      primaryColorOverride: event.primaryColor,
      primaryTextColorOverride: event.primaryTextColor,
      backgroundUrlOverride: event.backgroundUrl,
      logoUrlOverride: event.logoUrl,
    }),
  },
});
